import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

const ModalOkay = (props) => {
  const [show, setshow] = useState(props.okshow);

  const TheNextAction = () => {
    setshow(false);
    props.nextEvent();
  };

  return (
    <>
      <Modal
        show={props.okshow}
        onHide={TheNextAction}
        backdrop="static"
        keyboard={false}
        style={{ fontFamily: "Times New Roman", color: "brown" }}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "brown" }}>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            fontFamily: "Times New Roman",
          }}
        >
          <p>{props.message}</p>
          <hr />
          <div className="d-flex justify-content-end">
            <Button onClick={TheNextAction} variant="outline-success">
              Okay
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalOkay;
